export const TOO_COMPLEX_ERROR_CODE = 'too_complex';

export class TooComplexError extends Error {
    constructor(description, response) {
        super(description);
        this.name = 'TooComplexError';
        this.isTooComplex = true;
        this.response = response;
    }
}

export const isTooComplexResponse = data =>
    data?.success === false && (data.errorCode ?? data.error_code) === TOO_COMPLEX_ERROR_CODE;
